import { ref, watch } from 'vue';
import { getImageSize } from '@/utils/utils';

export function usePortraitMedia(source) {
  const isPortrait = ref(false);

  function setPortraitFromDimensions(width, height) {
    if (!width || !height) return;
    isPortrait.value = Number(width) < Number(height);
  }

  async function detectPortrait(item) {
    if (!item) {
      isPortrait.value = false;
      return;
    }
    if (item.isPortrait || Number(item.direction) === 3) {
      isPortrait.value = true;
      return;
    }
    if (Number(item.direction) === 1 || Number(item.direction) === 2) {
      isPortrait.value = false;
      return;
    }
    const url = item.imageUrl || item.thumb;
    if (!url) {
      isPortrait.value = false;
      return;
    }
    try {
      const size = await getImageSize(url);
      setPortraitFromDimensions(size.width, size.height);
    } catch {
      isPortrait.value = false;
    }
  }

  function handleVideoMetadata(event) {
    const video = event.target;
    if (video?.videoWidth && video?.videoHeight) {
      setPortraitFromDimensions(video.videoWidth, video.videoHeight);
    }
  }

  function handlePosterLoad(event) {
    const img = event.target;
    if (img?.naturalWidth && img?.naturalHeight) {
      setPortraitFromDimensions(img.naturalWidth, img.naturalHeight);
    }
  }

  watch(source, (item) => {
    detectPortrait(item);
  }, { immediate: true });

  return {
    isPortrait,
    handleVideoMetadata,
    handlePosterLoad,
  };
}
